import React from "react";
import Article from "./Article";
import { INITIAL_ARTICLES } from "../default_data";
import { retrieveNews } from "../services/backend";

import { useEffect, useState } from "react";
import { LinearProgress } from "@mui/material";

const ArticleFeed = ({ globalErrorHandler, language, level, keywords, onAdd, setSelectedWord, words, user_id }) => {

  const [articles, setArticles] = useState(INITIAL_ARTICLES);
  const [isLoading, setIsLoading] = useState(false);

  const messageStyle = {
    padding: '20px',
    textAlign: 'center',
    color: '#555',
    fontSize: '16px',
    lineHeight: '1.5'
  };

  const articleStyle = {
    padding: '20px',
    marginBottom: '20px',
    borderRadius: '8px',
    borderBottom: '2px solid #fff',
    boxShadow: 'none'
  };

  useEffect(() => {
    if (keywords.length === 0) {
      setIsLoading(false);
      return;
    }
    console.log(`Retrieving news with keywords: ${keywords.map(k => k.name).join(", ")} and language: ${language}`);
    retrieveNews(
      keywords.map(k => k.name),
      language,
      user_id,
      setArticles,
      globalErrorHandler,
      setIsLoading
    );
  }, [keywords, language]);

  let content;

  if (isLoading) {
    content = (
      <div style={messageStyle}>
        <LinearProgress color="primary" />
        Loading articles, please wait...
      </div>
    );
  } else if (keywords.length === 0) {
    content = (
      <div style={messageStyle}>
        It looks like you haven't added any interests yet! To get started, please add your first keyword and discover articles tailored just for you.
      </div>
    );
  } else if (articles.length === 0) {
    content = (
      <div style={messageStyle}>
        Oops! We couldn't find any articles matching your current topics. Try adjusting your topic list or check back later for new content.
      </div>
    );
  } else {
    content = articles.map((article, index) => (
      <div
        key={article.id || index}
        style={articleStyle}
      >
        <Article
          title={article.title}
          text={article.content}
          source={article.source}
          publishedAt={article.publishedAt}
          url={article.url}
          onAdd={onAdd}
          setSelectedWord={setSelectedWord}
          words={words}
          user_id={user_id}
          level={level}
          language={language}
        />
      </div>
    ));
  }

  return <div>{content}</div>;
};

export default ArticleFeed;
